export default __webpack_public_path__ + "static/media/evaluate-backdrop.0e6cef95.svg";